const initialState = {
    refreshTablet: false,
};

const employeeReducer = (state = initialState, action: { type: string; payload?: any }) => {
    switch (action.type) {
        case 'REFRESH_TABLE_EMPLOYEE_TOGGLE':
            return { ...state, refreshTablet: action.payload };
        default:
            return state;
    }
};

export default employeeReducer;